interface Options {
    timeEnabled?: boolean
}

export function dateToShortString(date: Date, options?: Options) {
    const { timeEnabled = false } = options ?? {}

    const pad = (n: number) => String(n).padStart(2, '0')

    const hh = pad(date.getHours())
    const mm = pad(date.getMinutes())
    const dd = pad(date.getDate())
    const MM = pad(date.getMonth() + 1)
    const yyyy = date.getFullYear()

    return `${timeEnabled ? `${hh}:${mm} ` : ``}${dd}/${MM}/${yyyy}`
}
